import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Two Column Media Text",
  tags: ["#page"],
}

export default defineBlock("content/two-column-media-text", (props) => {
  const ImageEl = props.imageLink?.url ? Link : "div"
  const imageProps = props.imageLink?.url
    ? {
        href: props.imageLink.url,
        target: props.imageLink.target || undefined,
        className: "w-cols-4 md:w-cols-2 md:px-5",
      }
    : {
        className: "w-cols-4 md:w-cols-2 md:px-5",
      }
  return (
    <div className="content-sized my-blockSpace grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-5 items-center">
      <Appear className="w-full flex flex-col gap-5 md:col-span-3">
        <ImageEl {...imageProps}>
          <ResponsiveImage {...props.image} className="w-full h-auto" />
        </ImageEl>
        {props.imageCaption && (
          <div className="type-mono-sm-regular text-slate600 [&_a]:underline">
            <div dangerouslySetInnerHTML={{ __html: props.imageCaption }} />
          </div>
        )}
      </Appear>
      <Appear slide delay={150} className="md:col-span-9">
        <EditableText
          store="body"
          className="w-full type-serif-lg-regular text-pretty [&_a]:underline"
          defaultValue="Body text"
          placeholder="Body text"
        />
      </Appear>
    </div>
  )
})
